module.exports = __webpack_public_path__ + "static/NGB-0f2aaa7d7331a94503442b413b806015.woff";